//Estilos
import './UserHomePage.css';

//Componentes
import SettingsInfoContainer from '../../components/settingsInfo/SettingsInfoContainer';

function UserHomePage() {
    return (
        <div className="userHomePage-container">
            <section className="userHomePage-section">
                <SettingsInfoContainer />
            </section>
        </div>
    );
}

export default UserHomePage;
